import { Navigate, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/library/documents")({
  component: () => <Navigate to="/library" replace />,
});
